export const paginationSettings = {

};
